import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const Navbar = ({ cartCount }) => {
  return (
    <nav className="bg-slate-900 text-white sticky top-0 z-50 border-b-4 border-lime-400">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <div className="flex items-center space-x-2">
            <SafeIcon icon={FiIcons.FiZap} className="text-lime-400 text-3xl" />
            <span className="font-black text-2xl tracking-tighter uppercase">VoltYard</span>
          </div>
          
          <div className="hidden md:flex space-x-8 font-bold text-sm tracking-wide text-gray-300">
            <a href="#tools" className="hover:text-lime-400 transition-colors uppercase">Tools</a>
            <a href="#kits" className="hover:text-lime-400 transition-colors uppercase">Starter Kits</a>
            <a href="#battery" className="hover:text-lime-400 transition-colors uppercase">Battery System</a>
            <a href="#support" className="hover:text-lime-400 transition-colors uppercase">Support</a>
          </div>

          <div className="flex items-center">
            <button className="relative p-2 text-gray-300 hover:text-lime-400 transition-colors">
              <SafeIcon icon={FiIcons.FiShoppingCart} className="text-2xl" />
              {cartCount > 0 && (
                <span className="absolute top-0 right-0 bg-lime-400 text-slate-900 text-xs font-bold rounded-full h-5 w-5 flex items-center justify-center">
                  {cartCount}
                </span>
              )}
            </button>
            <button className="md:hidden ml-4 text-gray-300">
              <SafeIcon icon={FiIcons.FiMenu} className="text-2xl" />
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;